import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';
import ErrorBoundary from './utilities/ErrorBoundary';

// StrictMode is back. Every brand page's on-mount fetch is now guarded
// with a `cancelled` flag in its useEffect cleanup (see Overview /
// Notifications / Activity / IAM / ApiKeys / Webhooks / Inbox / Orders
// / Discounts / LowStock / Reviews / Audience / PageBuilder /
// MailManager / NftStudio + all the Ecommerce + Accounting tabs), so
// the dev-only double-mount no longer causes duplicate toasts or
// stale state writes. `fetchAPIFrom` also accepts an AbortSignal for
// callers that want true request cancellation. Re-enabling here gets
// us the cleanup-bug surfacing benefit in dev without the side effects.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);

serviceWorker.unregister();
